"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasAllTemplateParams = void 0;
var format_template_1 = require("./format-template");
var hasAllTemplateParams = function (format, params) {
    var templatePlaceholders = format.match(format_template_1.templatePlaceholderRegex); // e.g. 'Hello ${a} ${b}' -> ['${a}', '${b}']
    if (!templatePlaceholders)
        return true;
    return templatePlaceholders.every(function (placeholder) {
        var paramKey = format_template_1.getParamKeyFromTemplatePlaceholder(placeholder); // e.g. ${a} -> a
        return params[paramKey] !== undefined;
    });
};
exports.hasAllTemplateParams = hasAllTemplateParams;
//# sourceMappingURL=has-all-template-params.js.map